<template>
    <section class="bg-[#f9f9f9] py-20 px-4">
      <div class="max-w-6xl mx-auto text-center mb-16">
        <h2 class="text-2xl md:text-4xl font-bold mb-2">
          Ei, você precisa saber disso...
        </h2>
        <p class="text-sm text-gray-500">
          veja algumas vantagens que você encontra somente aqui
        </p>
      </div>
  
      <div class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div
          v-for="(item, index) in vantagens"
          :key="index"
          class="bg-white rounded-2xl shadow p-6 text-center"
        >
          <div class="flex justify-center mb-4">
            <img :src="item.icone" :alt="item.titulo" class="w-40 h-40" />
          </div>
          <h3 class="font-bold text-lg mb-2">{{ item.titulo }}</h3>
          <p class="text-sm text-gray-600">{{ item.descricao }}</p>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const vantagens = [
 
    {
      titulo: 'Suporte especializado',
      descricao:
        'Suporte via ticket para dúvidas, de forma ilimitada, ao serviço contratado.',
      icone: '/icones-vantagens/suporte.svg'
    },
    {
      titulo: 'Desempenho',
      descricao:
        'Usamos os novos processadores AMD EPYC™ criados para lidar com cargas de trabalho intensas. Muito mais desempenho para o seu negócio.',
      icone: '/icones-vantagens/desempenho.svg'
    },
    {
      titulo: 'Proteção DDoS',
      descricao:
        'Nossa infraestrutura é protegida no nível da rede. Você pode ter certeza de que suas instâncias serão resilientes aos ataques mais populares.',
      icone: '/icones-vantagens/ddos.svg'
    }
  ]
  </script>
  